import * as Sentry from "@sentry/react";
import { getEnvironment } from "./config/app-config";

Sentry.init({
  dsn: "https://92de121dbb955ae4b9d5796b43e408cc@o4507094863839232.ingest.de.sentry.io/4509524579713104",
  sendDefaultPii: true,
  environment: getEnvironment(window.location),
  integrations: [
    // send console.log, console.error, and console.warn calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
  ],
  _experiments: { enableLogs: true },
});
